module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [(_vm.type === 'night') ? _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoDark
    }
  })]) : _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoLight
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db55905c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 141
// module chunks = 0